// Vant 按需注册（仅本项目用到的组件与函数式 API）
import Vue from 'vue';
import {
    Button,
    Field,
    Popup,
    Icon,
    Loading,
    RadioGroup,
    Radio,
    Checkbox,
    CheckboxGroup,
    Empty,
    NavBar,
    Toast,
    Dialog,
} from 'vant';

const components = {
    Button,
    Field,
    Popup,
    Icon,
    Loading,
    RadioGroup,
    Radio,
    Checkbox,
    CheckboxGroup,
    Empty,
    NavBar,
};

// 批量注册组件；Toast/Dialog 通过 Vue.use 挂载 $toast / $dialog 函数式调用
Object.keys(components).forEach((key) => Vue.use(components[key]));
Vue.use(Toast);
Vue.use(Dialog);
